const CATEGORIES = {
  other: "Kita",
  bags: "Maiseliai",
  purses: "Rankinukai",
  special: "DaiktaiS",
  itemsA: "DaiktaiA",
  itemsB: "DaiktaiB",
  itemsL: "DaiktaiL",
  itemsW: "DaiktaiW",
  itemsT: "DaiktaiT",
  itemsK: "DaiktaiK",
  itemsM: "DaiktaiM",
  itemsC: "DaiktaiC",
  itemsP: "DaiktaiP",
};

export default CATEGORIES;
